import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'

import { paths } from '@/lib/paths'
import { useSeo } from '@/lib/seo'
import { useLocale } from '@/lib/useLocale'

export function NotFoundPage() {
  const locale = useLocale()
  const { t } = useTranslation()

  useSeo({
    title: `${t('errors.notFoundTitle')} — ${t('site.name')}`,
    description: t('errors.notFoundText'),
    path: '/404',
    locale,
    // Keeps empty pages out of the index and out of the sitemap's way.
    noIndex: true,
  })

  return (
    <div className="container-page flex min-h-[50vh] flex-col items-center justify-center py-20 text-center">
      <p className="font-[family-name:var(--font-display)] text-6xl text-stone-300">404</p>
      <h1 className="mt-4 text-3xl">{t('errors.notFoundTitle')}</h1>
      <p className="mt-3 max-w-md text-stone-600">{t('errors.notFoundText')}</p>
      <Link to={paths.home(locale)} className="btn btn-primary mt-8">
        {t('errors.goHome')}
      </Link>
    </div>
  )
}
